
import LotterySectionTitle from "./LotterySectionTitle.vue";
import {
  filterWheelDisplayPrizes,
  getPrizeImage,
  getPrizeName,
} from "./lotteryUtils";

export default {
  name: "LotteryActivityPrizes",
  components: {
    LotterySectionTitle,
  },
  props: {
    prizes: {
      type: Array,
      default: () => [],
    },
    copy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activityPrizeList() {
      return filterWheelDisplayPrizes(this.prizes).slice(0, 9);
    },
  },
  methods: {
    // 统一处理奖品图片字段和缩略参数。
    getPrizeImage,
    // 统一处理奖品名称字段和详情拼接。
    getPrizeName,
  },
};
